export default __webpack_public_path__ + "static/media/LoginPic.9a9deab0.svg";